function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    height: ",
        ";\n    width: ",
        ";\n\n    svg {\n        height: 100%;\n        width: 100%;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        background-color: ",
        ";\n        color: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                  background-color: transparent;\n                  padding-left: 0;\n                  padding-right: 0;\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                  gap: 0;\n                  padding-left: ",
        ";\n              "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-height: ",
        ";\n    padding: 0 ",
        ";\n    border-radius: ",
        ";\n    flex: 0;\n    gap: ",
        ";\n    white-space: nowrap;\n    box-sizing: border-box;\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";
import { globalLabel } from "../typography";
import { semanticColor } from "../palette/semantic";
export var StatusIndicator = function(props) {
    var className = props.className, iconLeft = props.iconLeft, iconRight = props.iconRight, variant = props.variant, blend = props.blend, compact = props.compact, children = props.children;
    return /*#__PURE__*/ _jsxs(Container, {
        className: className,
        variant: variant,
        blend: blend,
        compact: compact,
        children: [
            iconLeft && /*#__PURE__*/ _jsx(IconContainer, {
                children: iconLeft
            }),
            children,
            iconRight && /*#__PURE__*/ _jsx(IconContainer, {
                children: iconRight
            })
        ]
    });
};
var IconContainer = styled.div.withConfig({
    componentId: "sc-c1978697-0"
})(_templateObject(), rem(16), rem(16));
var Container = styled.div.withConfig({
    componentId: "sc-c1978697-1"
})(_templateObject4(), rem(20), rem(8), rem(10), rem(4), globalLabel, function(param) {
    var variant = param.variant;
    return css(_templateObject1(), semanticColor("status-".concat(variant, "-bg")), semanticColor("status-".concat(variant, "-fg")));
}, function(param) {
    var blend = param.blend;
    return blend ? css(_templateObject2()) : null;
}, function(param) {
    var compact = param.compact;
    return compact ? css(_templateObject3(), rem(4)) : null;
});
